import React, { Component } from 'react'
import { connect } from 'react-redux'
import './measurements.css'
import * as axios from 'axios'
import { GoogleReCaptcha } from 'react-google-recaptcha-v3'
class Measurements extends Component {
  constructor(props) {
    super(props)
    this.state = {
      recaptchaRef: React.createRef(),
      name: '',
      email: '',
      captcha: null,
      gdpr: false,
      list: '0NM7PdmDc9tzduhnusyuNQ',
      emailValid: false,
      nameValid: false,
      formValid: false,
      showTerms: false,
      click: false,
    }
    this.SendToSendy = this.SendToSendy.bind(this)
    this.activeButom = this.activeButom.bind(this)
    this.validateAltura = this.validateAltura.bind(this)
    this.validateEdad = this.validateEdad.bind(this)
    this.validatePeso = this.validatePeso.bind(this)
    this.handleUserInput = this.handleUserInput.bind(this)
    this.validateField = this.validateField.bind(this)
    this.handleClick = this.handleClick.bind(this)
    this.handleVerify = this.handleVerify.bind(this)
    this.focus = this.focus.bind(this)
  }
  setActive(i) {
    switch (i) {
      case 0:
        return 'Métrico'
      case 1:
        return 'Imperial'
      default:
        return 'Métrico'
    }
  }
  validateEdad() {
    if (this.props.edad) {
      if (this.props.edad >= 18 && this.props.edad <= 99) return 'valid'
      else return 'danger'
    } else return ''
  }
  validatePeso() {
    if (this.props.peso) {
      if (this.props.type_measure === 0) {
        if (this.props.peso >= 30 && this.props.peso < 200) return 'valid'
        else return 'danger'
      } else {
        if (this.props.peso >= 66 && this.props.peso < 440) return 'valid'
        else return 'danger'
      }
    }
  }
  validateAltura() {
    if (this.props.altura) {
      if (this.props.type_measure === 1) {
        if (this.props.altura >= 55 && this.props.altura <= 84) return 'valid'
        else return 'danger'
      } else {
        if (this.props.altura >= 139 && this.props.altura < 220) return 'valid'
        else return 'danger'
      }
    } else return ''
  }
  handleUserInput(e) {
    console.log('handle', e.target.value)
    var name = e.target.name
    var value = e.target.value
    this.setState({ [name]: value })
    this.validateField(name, value)
    if (name === 'name') {
      this.props.changeName(value)
    }
    if (name === 'email') {
      this.props.changeEmail(value)
    }
  }
  activeButom() {
    return (
      this.state.formValid &&
      this.validateAltura() === 'valid' &&
      this.validateEdad() === 'valid' &&
      this.validatePeso() === 'valid' &&
      this.state.captcha !== null
    )
  }
  async SendToSendy() {
    if (this.activeButom()) {
      try {
        const name = this.state.name
        const parts = name.split(' ')
        const firstName = parts.shift() // Paul
        const lastName = parts.join(' ')
        const url = 'https://services.leadconnectorhq.com/contacts/'
        var body = JSON.stringify({
          firstName,
          lastName,
          email: this.state.email,
          name: name,
          gender: this.props.sexo,
          source: 'Calculadora de Calorías y Macronutrientes',
          locationId: 'qh2gWMwWy08RaBPYmU7H',
          tags: ['Calculadora de Calorías'],
        })
        const response = await axios({
          url: url,
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
            Authorization: `Bearer ${process.env.REACT_APP_HIGLEVEL_TOKEN}`,
            version: '2021-07-28',
          },
          data: body, // Información enviada desde el cliente React
        })
        if (response.data?.contact?.id) {
          this.props.setContactId(response.data.contact.id)
        }
        this.props.changePage(12)
      } catch (error) {
        if (error.response) {
          if (error.response.data?.meta?.contactId) {
            await this.changeTag(error.response.data.meta.contactId)
            this.props.setContactId(error.response.data.meta.contactId)
            this.props.changePage(12)
          }
          // Respuesta del servidor con error (422 en este caso)
          console.error('Error del servidor:', error.response.data)
        }
      }
    }
  }
  async changeTag(contactId) {
    if (this.props.contactId) {
      const url = `https://services.leadconnectorhq.com/contacts/${contactId}/tags`
      var body = JSON.stringify({
        tags: ['Calculadora de Calorías'],
      })
      const response = await axios({
        url: url,
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
          Authorization: `Bearer ${process.env.REACT_APP_HIGLEVEL_TOKEN}`,
          version: '2021-07-28',
        },
        data: body,
      })
    }
  }
  async handleClick(event) {
    /* event.preventDefault() */
    /* this.setState({ click: true }) */

    /* TODO: COMENTAR AL SUBIR A PRODUCCION */
    //this.props.changePage(12)
    if (this.activeButom()) {
      this.SendToSendy()
    } else {
      return false
    }
  }
  validateField(fieldName, value) {
    let emailValid = this.state.emailValid
    let nameValid = this.state.nameValid

    switch (fieldName) {
      case 'email':
        emailValid = value.match(/^([\w.%+-]+)@([\w-]+\.)+([\w]{2,})$/i)
        break
      case 'name':
        nameValid = value.length >= 3
        break
      default:
        break
    }
    this.setState({
      formValid: emailValid && nameValid,
      emailValid: emailValid,
      nameValid: nameValid,
    })
  }

  handleVerify(token) {
    this.setState({ captcha: token })
  }
  focus(event) {
    console.log(event.target.offsetTop)
    window.scroll({
      top: event.target.offsetBottom,
      behavior: 'smooth',
    })
  }
  render() {
    return (
      <div className="container">
        <div className="row">
          <div className="section-text col-md-12 col-lg-6">Medidas</div>

          <div className="options text-start col-md-12 col-lg-6">
            <p>
              Para terminar, solo nos hace faltan algunos datos adicionales y
              puedes hacer click en <strong>"calcular"</strong>
            </p>
            <div className="type">
              <p className="active">
                {this.setActive(this.props.type_measure)}
              </p>
              <p
                onClick={() =>
                  this.props.changeTypeMeasures(
                    this.props.type_measure === 0 ? 1 : 0
                  )
                }
              >
                {this.setActive(this.props.type_measure === 0 ? 1 : 0)}
              </p>
            </div>

            <div>
              <div className="row">
                <div className="col-12 col-md-4">
                  <input
                    type="number"
                    placeholder="Edad"
                    className={this.validateEdad()}
                    maxLength={2}
                    onChange={(event) => this.props.changeEdad(event)}
                    defaultValue={this.props.edad}
                    step={6}
                    pattern="[0-9]"
                  />
                </div>

                <div className="group-input col-12 col-md-4">
                  <input
                    type="number"
                    className={this.validatePeso()}
                    onChange={(event) => this.props.changePeso(event)}
                    value={this.props.peso}
                    placeholder="Peso"
                    maxLength={6}
                  />
                  {this.props.type_measure === 0 ? (
                    <span>kg</span>
                  ) : (
                    <span>lbs</span>
                  )}
                </div>
                {this.props.type_measure === 0 ? (
                  <div className="group-input col-12 col-md-4">
                    <input
                      type="number"
                      className={this.validateAltura()}
                      onChange={(event) => this.props.changeAltura(event)}
                      defaultValue={this.props.altura}
                      placeholder="Altura"
                      maxLength="6"
                    />
                    <span>cm</span>
                  </div>
                ) : (
                  <div className="group-input col-12 col-md-4">
                    <select
                      onChange={(event) => this.props.changeAltura(event)}
                      className={this.validateAltura()}
                      value={this.props.altura}
                      placeholder="Altura"
                    >
                      <option disabled>Altura</option>
                      <option value={55}> 4ft 7in</option>
                      <option value={56}> 4ft 8in</option>
                      <option value={57}> 4ft 9in</option>
                      <option value={58}> 4ft 10in</option>
                      <option value={59}> 4ft 11in</option>
                      <option value={60}> 5ft 0in</option>
                      <option value={61}> 5ft 1in</option>
                      <option value={62}> 5ft 2in</option>
                      <option value={63}> 5ft 3in</option>
                      <option value={64}> 5ft 4in</option>
                      <option value={65}> 5ft 5in</option>
                      <option value={66}> 5ft 6in</option>
                      <option value={67}> 5ft 7in</option>
                      <option value={68}> 5ft 8in</option>
                      <option value={69}> 5ft 9in</option>
                      <option value={70}> 5ft 10in</option>
                      <option value={71}> 5ft 11in</option>
                      <option value={72}> 6ft 0in</option>
                      <option value={73}> 6ft 1in</option>
                      <option value={74}> 6ft 2in</option>
                      <option value={75}> 6ft 3in</option>
                      <option value={76}> 6ft 4in</option>
                      <option value={77}> 6ft 5in</option>
                      <option value={78}> 6ft 6in</option>
                      <option value={79}> 6ft 7in</option>
                      <option value={80}> 6ft 8in</option>
                      <option value={81}> 6ft 9in</option>
                      <option value={82}> 6ft 10in</option>
                      <option value={83}> 6ft 11in</option>
                      <option value={84}> 7ft 0in</option>
                    </select>
                  </div>
                )}
              </div>

              <div className={'form-end'}>
                <input
                  name="name"
                  value={this.state.name}
                  type="text"
                  placeholder="Aquí tu primer nombre..."
                  className={
                    this.state.name !== ''
                      ? this.state.nameValid
                        ? 'valid'
                        : 'danger'
                      : ''
                  }
                  onChange={(e) => this.handleUserInput(e)}
                />
                <input
                  name="email"
                  value={this.state.email}
                  type="email"
                  placeholder="Y aquí tu email..."
                  className={
                    this.state.email !== ''
                      ? this.state.emailValid
                        ? 'valid'
                        : 'danger'
                      : ''
                  }
                  onChange={(e) => this.handleUserInput(e)}
                />

                <GoogleReCaptcha onVerify={this.handleVerify} />
                <div className="acuerdo">
                  <p style={{ textAlign: 'start' }}>
                    Al hacer click en "Calcular", estás de acuerdo en que tus
                    datos sean almacenados y tratados por FullMusculo LLC
                  </p>
                </div>
              </div>
              <div
                style={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'center',
                }}
              >
                <label
                  style={{ fontWeight: 'bold', margin: 0 }}
                  onClick={() => this.props.changePage(this.props.page - 1)}
                >
                  <i className="fas fa-angle-left" /> ANTERIOR
                </label>

                <button
                  /* className={this.activeButom() ? 'done' : ''} */
                  onClick={() => this.handleClick()}
                  disabled={!this.activeButom()}
                  style={{
                    margin: 0,
                    width: '65%',
                    backgroundColor: '#3a6ea7',
                    marginLeft: '20px',
                    color: 'white',
                  }}
                >
                  Calcular
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}
const mapStateToProps = (state) => ({
  type_measure: state.type_measure,
  edad: state.edad,
  peso: state.peso,
  altura: state.altura,
  page: state.page,
  state: state,
  name: state.name,
  sexo: state.sexo,
})
const mapDispatchToProps = (dispatch) => ({
  changeName(name) {
    dispatch({
      type: 'CHANGE_NAME',
      name,
    })
  },
  changeEmail(email) {
    dispatch({
      type: 'CHANGE_EMAIL',
      email,
    })
  },
  changeTypeMeasures(type) {
    dispatch({
      type: 'CHANGE_TYPE_MEASURE',
      type_measure: type,
    })
  },
  changeEdad(event) {
    dispatch({
      type: 'CHANGE_EDAD',
      edad: event.target.value.slice(0, 2),
    })
  },
  changePeso(event) {
    dispatch({
      type: 'CHANGE_PESO',
      peso: event.target.value,
    })
  },
  changeAltura(event) {
    dispatch({
      type: 'CHANGE_ALTURA',
      altura: Number.parseInt(event.target.value),
    })
  },
  changePage(page) {
    dispatch({
      type: 'CHANGE_PAGE',
      page: page,
    })
  },
  setContactId(contactId) {
    dispatch({
      type: 'SET_CONTACT_ID',
      contactId,
    })
  },
})
export default connect(mapStateToProps, mapDispatchToProps)(Measurements)
